// extracted by mini-css-extract-plugin
module.exports = {"icon":"FavoriteButton_icon__23HNL"};